import React from 'react';
import {
    Wrapper,
    Element,
    ElementTitle,
    ElementName,
    ElementDescription,
    FlexWrapper
} from './NoInformation.styles';

export function NoInformation() {
    const FakeItems = () => {
        return (
            <Element>
                <ElementTitle></ElementTitle>
                <FlexWrapper>
                    <ElementName></ElementName>
                    <ElementDescription></ElementDescription>
                </FlexWrapper>
                <FlexWrapper>
                    <ElementName></ElementName>
                    <ElementDescription></ElementDescription>
                </FlexWrapper>
                <FlexWrapper>
                    <ElementName></ElementName>
                    <ElementDescription></ElementDescription>
                </FlexWrapper>
            </Element>
        )
    }
    return (
        <Wrapper>
            <p>No information available yet</p>
            {FakeItems()}
            {FakeItems()}
        </Wrapper>
    )
}
